import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { imgUrl } from "@/lib/api";
import { euro } from "@/lib/shop";

const Item = ({ p, dup }) => (
  <Link
    to={`/prodotto/${p.id}`}
    tabIndex={dup ? -1 : 0}
    aria-hidden={dup ? "true" : undefined}
    data-testid={dup ? undefined : `new-arrival-${p.id}`}
    className="flex w-56 shrink-0 items-center gap-3 rounded-2xl bg-white p-2 pr-3 transition-transform duration-150 hover:-translate-y-0.5"
  >
    <div className="h-16 w-16 shrink-0 overflow-hidden rounded-xl bg-white">
      {p.images?.[0] && <img src={imgUrl(p.images[0])} alt={dup ? "" : p.name} loading="lazy" className="h-full w-full object-contain" />}
    </div>
    <div className="min-w-0">
      <div className="line-clamp-2 text-xs font-bold leading-snug text-[#0b0b0f]">{p.name}</div>
      {p.price != null && <div className="mt-0.5 font-display text-sm font-extrabold text-[#0b0b0f]">{euro(p.price)}</div>}
    </div>
  </Link>
);

export const NewArrivals = ({ products }) => {
  const list = products.slice(0, 12);
  if (list.length === 0) return null;
  return (
    <section data-testid="new-arrivals-strip" className="neon-purple mt-6 overflow-hidden rounded-3xl bg-[#120a1f] py-4">
      <h2 className="flex items-center gap-2 px-4 text-base font-extrabold uppercase tracking-[0.2em] neon-text md:text-lg">
        <Sparkles className="h-4 w-4" /> Nuovi arrivi
      </h2>
      <div className="marquee mt-3">
        <div className="marquee-track gap-3 pl-3" style={{ animationDuration: `${Math.max(20, list.length * 6)}s` }}>
          {list.map((p) => <Item key={p.id} p={p} />)}
          {list.map((p) => <Item key={`d-${p.id}`} p={p} dup />)}
        </div>
      </div>
    </section>
  );
};
